import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  muted: { color: colors.grey1 },
  root: {
    backgroundColor: 'white',
    margin: '0 auto',
    maxWidth: 1180,
    position: 'sticky',
    padding: `40px 26px 0`,
    top: 50,
    zIndex: 100,
    [theme.breakpoints.down('lg')]: {
      top: 40,
    },
    [theme.breakpoints.down('md')]: {
      top: 50,
      padding: `${theme.spacing(2.5)} ${theme.spacing(1.5)} 0`,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        top: 40,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        top: 50,
        padding: `${theme.spacing(2.5)} ${theme.spacing(1.5)} 0`,
      }),
    },
  },
  title: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      fontSize: 22,
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 22,
        marginBottom: theme.spacing(2),
      }),
    },
  },
  buttonContainer: {
    alignItems: 'center',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(0.5),
      '& h3': {
        fontSize: 14,
      },
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(0.5),
        '& h3': {
          fontSize: 14,
        },
      }),
    },
  },
  editQty: {
    fontSize: 14,
    [theme.breakpoints.down('sm')]: {
      padding: '2px',
    },
    [theme.breakpoints.downLandscape('sm')]: {
      ...(theme.isMobileDevice && {
        padding: '2px',
      }),
    },
  },
}));
